import { render, staticRenderFns } from "./Ticket1.vue?vue&type=template&id=3cda70da"
import script from "./Ticket1.vue?vue&type=script&lang=js"
export * from "./Ticket1.vue?vue&type=script&lang=js"
import style0 from "./Ticket1.vue?vue&type=style&index=0&id=3cda70da&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports